import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VideoCoordinatorService {
  private activePlayer: any = null;
  private apiPromise: Promise<void> | null = null;

  loadYouTubeApi(): Promise<void> {
    if (window.YT && window.YT.Player) {
      return Promise.resolve();
    }

    if (this.apiPromise) {
      return this.apiPromise;
    }

    this.apiPromise = new Promise((resolve) => {
      const existingCallback = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        if (typeof existingCallback === 'function') existingCallback();
        resolve();
      };

      if (!document.getElementById('youtube-iframe-api')) {
        const tag = document.createElement('script');
        tag.id = 'youtube-iframe-api';
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
      }
    });

    return this.apiPromise;
  }

  setActive(player: any): void {
    if (this.activePlayer && this.activePlayer !== player) {
      this.safePause(this.activePlayer);
    }
    this.activePlayer = player;
  }

  clear(player: any): void {
    if (this.activePlayer === player) {
      this.activePlayer = null;
    }
  }

  private safePause(player: any): void {
    try {
      if (player && typeof player.pauseVideo === 'function') {
        player.pauseVideo();
      }
    } catch {
      // Player wasn't ready or was already destroyed — ignore.
    }
  }
}